import { CSSObject } from '@chakra-ui/react';
import loader from '../../../../assets/fiestabet/images/loader.svg';

export const SpinnerLoader: CSSObject = {
  bgImage: `url(${loader})`,
  boxSize: '40',
};
